<template>
	<div id="content">
        <div class="box">
            <div class="row">
                <div class="col-10">
                    <e-select
                        v-model="duplicate_selected"
                        id="tierDuplicate"
                        :placeholder="$t('table.tables.search_duplicate')"
                        :selectedLabel="$t('global.selected_label')"
                        :options="all_duplicate"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        track-by="code"
                        label="label"
                    >
                        <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                    </e-select>
                </div>
                <div class="col-2">
                    <b-button variant="primary" block @click="search" :disabled="!duplicate_selected">{{ $t("global.rechercher") }}</b-button>
                </div> 
                <div class="col-12">
                    <CustomTable
                        id_table="tiers_search_duplicate"
                        primaryKey="tiers_id"
                        :hrefsRoutes="config_table_hrefs"
                        :items="tiers"
                        :busy.sync="table_busy"
                        :externSlotColumns="['phone_numero']"
                    >
                        <template v-slot:[`custom-slot-cell(phone_numero)`]="{ data }">
                            <span v-for="phone in data.phones" :key="phone.phone_id">
                                <a :href="'tel:'+phone.phone_combine">{{ phone.phone_combine }}</a><br>
                            </span>
                        </template>
                    </CustomTable>
                </div>
            </div>
        </div>
	</div>
</template>

<script type="text/javascript">
    import Tiers from "@/mixins/Tiers.js"
  
	export default {
		name: "TiersSearchDuplicate",
		mixins: [Tiers],
		data () {
			return {
                duplicate_selected: '',
                table_busy: false,
                tiers:[],
                config_table_hrefs: {
                    'tiers_rs': {
                        routeUniqueName: 'tiersFiche',
                        routeName: 'tiersFiche',
                        params: {
                            tiers_id: 'tiers_id'
                        }
                    }
                },
                all_duplicate: [{
					code: 'tiers_rs',
					label: this.getTrad('tiers.rs')
				},{
					code: 'tiers_siret',
					label: this.getTrad('tiers.siret')
				},{
					code: 'tiers_siren',
					label: this.getTrad('tiers.siren')
				},{
					code: 'tiers_vat',
					label: this.getTrad('tiers.num_tva')
				},{
					code: 'tiers_phone',
					label: this.getTrad('tiers.phone')
				},{
					code: 'tiers_mail',
					label: this.getTrad('tiers.email')
				  },
                //{
				// 	code: 'tiers_fullname',
				// 	label: this.getTrad('tiers.fullname')
				// },
                ]

			}
		}, 
		mounted() {
            this.init_component()
        },
        methods: {
            async init_component() {
            	
			},

            async search() {
                this.table_busy = true
                this.tiers = await this.searchDuplicate(this.duplicate_selected.code)
                this.table_busy = false
              
            }

        },
		components: {
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
		}
	}
</script>
